import React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, CircularProgress, Dialog, IconButton, Typography } from '@mui/material';

/**
 * Shows the server-rendered report PDF in the browser's own PDF viewer, which brings
 * zoom, print and save with it.
 */
type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  /** Object URL of the PDF; null while it is still being fetched. */
  pdfUrl: string | null;
};

const ReportPdfViewerDialog = ({ open, onClose, title, pdfUrl }: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="lg"
    PaperProps={{ sx: { height: '90vh', bgcolor: '#1a2336', color: '#e2e8f0' } }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        py: 1,
        borderBottom: '1px solid #2d3f5a',
      }}
    >
      <Typography sx={{ fontSize: 15, fontWeight: 600 }}>{title}</Typography>
      <IconButton
        onClick={onClose}
        size="small"
        aria-label="Close"
        sx={{ color: '#e2e8f0' }}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    </Box>
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {pdfUrl ? (
        <Box
          component="iframe"
          src={pdfUrl}
          title={title}
          sx={{ width: '100%', height: '100%', border: 0, bgcolor: '#fff' }}
        />
      ) : (
        <CircularProgress sx={{ color: '#e2e8f0' }} />
      )}
    </Box>
  </Dialog>
);

export default ReportPdfViewerDialog;
